import { getProductNameByName } from './productTypes';

export const getPluralProductName = (name, amount = 1) => {
  return getProductNameByName(name, amount);
};
